import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { CustomFieldObjectType } from "../../../clients/graphqlTypes.js";
import { useCustomFieldConfigQuery } from "./customFieldConfigs.generated.js";

export const useCustomFieldConfig = (objectType?: CustomFieldObjectType) => {
  const client = useApolloClient();
  const query = useCustomFieldConfigQuery({
    client,
    variables: { filterObjectType: objectType },
  });
  return {
    customFieldConfig:
      getDataOrNull(query.data?.customFieldConfig)?.customFieldConfig ?? [],
    loading: query.loading,
    error: query.error,
  };
};
